const messages = {
  title: "Kainoraščiai ir produktų brošiūros",
  title_media: "Kainoraščiai ir produktų brošiūros",
  description:
    "Atsisiųskite naujausias brošiūras ir lankstinukus apie Bridgestone ir Firestone padangas lengviesiems automobiliams, SUV ir komerciniams transporto priemonėms.",
  short_description:
    "Čia rasite medžiagą socialiniams tinklams, in-store TV ir daugiau.",
  mediaCategories: {
    products: "Produktai",
    brand_and_solutions: "Prekės ženklas ir sprendimai",
    season_and_promotions: "Sezonas ir akcijos",
    format: "Formatas",
    cars_and_vans: "Lengvasis automobilis, SUV, komercinis",
    truck_and_buses: "Sunkvežimis ir autobusas",
    motorcycle: "Motociklas",
    agriculture: "Žemės ūkis",
    construction_machinery: "Statybinė technika",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Medžiagos",
    brochures: "Produktų brošiūros",
    price_list: "Kainoraščiai",
    materials: "Medžiagos",
    video_in_store: "Vaizdo įrašas su subtitrais",
    video_online: "Vaizdo įrašas be subtitrų",
    video: "Vaizdo įrašas",
    banner_website: "Baneris",
    banner_social_media: "Socialiniai tinklai",
    logos: "Logotipai",
    summer: "Vasara",
    winter: "Žiema",
    all_season: "Visi sezonai",
    promotions: "Akcijos",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIJŲ BIBLIOTEKA",
    description:
      "Sveiki atvykę į medijų skyrių, skirtą   \n" +
      "Bridgestone ir Firestone produktams.  \n <br> <br>" +
      "Atrasite produktų vizualizacijų,   \n" +
      "logotipų, taip pat platų   \n" +
      "banerių, vaizdo įrašų ir skaitmeninių medžiagų   \n" +
      "asortimentą naudoti savo svetainėje arba   \n" +
      "socialinėse žiniasklaidos priemonėse.  ",
    bDrive: {
      title: "Produktų nuotraukos",
      description:
        "Dabartinius vaizdus   \n" +
        "galima atsisiųsti   \n" +
        "iš mūsų B-\n" +
        "DRIVE portalo.  ",
    },
  },
  buttons: {
    media: "ATRASTI",
  },
  searchMedia: "Įveskite raktinį žodį",
  searchResults: "Paieškos rezultatai",
};

export default {
  messages,
};
